'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _truncateDom = require('truncate-dom');

var _truncateDom2 = _interopRequireDefault(_truncateDom);

var _striptags = require('striptags');

var _striptags2 = _interopRequireDefault(_striptags);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Truncate = function (_Component) {
  _inherits(Truncate, _Component);

  function Truncate() {
    var _Object$getPrototypeO;

    var _temp, _this, _ret;

    _classCallCheck(this, Truncate);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_Object$getPrototypeO = Object.getPrototypeOf(Truncate)).call.apply(_Object$getPrototypeO, [this].concat(args))), _this), _this.handleResize = function () {
      _this.forceUpdate();
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Truncate, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.truncate = (0, _truncateDom2.default)(this.refs.scope);
      this.forceUpdate();
      window.addEventListener('resize', this.handleResize);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.handleResize);
    }
  }, {
    key: 'getRenderHtml',
    value: function getRenderHtml() {
      var _props = this.props;
      var html = _props.html;
      var line = _props.line;
      var truncateText = _props.truncateText;
      var isStripTags = _props.isStripTags;
      var allowedTags = _props.allowedTags;

      var stripedHtml = html;

      if (isStripTags) {
        stripedHtml = (0, _striptags2.default)(html, allowedTags);
      }

      return this.truncate(stripedHtml, line, truncateText);
    }
  }, {
    key: 'render',
    value: function render() {
      var html = '';
      if (this.refs.scope) {
        html = this.getRenderHtml();
      }

      return _react2.default.createElement('div', _extends({}, this.props, {
        ref: 'scope',
        dangerouslySetInnerHTML: { __html: html }
      }));
    }
  }]);

  return Truncate;
}(_react.Component);

Truncate.propTypes = {
  html: _react.PropTypes.string,
  line: _react.PropTypes.number,
  truncateText: _react.PropTypes.string,
  isStripTags: _react.PropTypes.bool,
  allowedTags: _react.PropTypes.string
};
Truncate.defaultProps = {
  html: '',
  line: 1,
  truncateText: '...',
  isStripTags: true,
  allowedTags: '<em>'
};
exports.default = Truncate;


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-truncate-dom/lib/index.js
 ** module id = 1171
 ** module chunks = 0
 **/